<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title"><span v-show="!product.Id">Add</span><span v-show="product.Id">Edit</span> Product</p>
    </div>
    <div class="modal-card-body">
      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field label="Name">
            <b-input v-model="product.Name"></b-input>
          </b-field>
          <b-field label="Price">
            <b-input v-model="product.Price" type="number"></b-input>
          </b-field>
          <b-field label="Description">
            <b-input type="textarea" v-model="product.Description"></b-input>
          </b-field>
          <b-field label="PlanId" v-show="product.planId">
            <span>{{product.planId}}</span>
          </b-field>
          <b-button type="is-danger" size="is-small" @click="RemovePlan()" v-show="product.planId">Remove</b-button>

          <div v-show="!product.planId && product.Id">
            <p>
              This is a one-time purchase item. To make this a monthly subscription item, click the button below.
            </p>
            <span>
              <b-button type="is-warning" @click="CreatePlan()" :class="{'is-loading':product.creatingPlan}">Create a new plan</b-button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <div>
        <b-button @click="$emit('close')">Cancel</b-button>
      </div>
      <div>
        <b-button type="is-danger" @click="Delete" v-if="product.Id && !product.deleted">Delete</b-button>
        <b-button type="is-danger" @click="Undelete" v-if="product.Id && product.deleted">Undelete</b-button>
        <b-button type="is-primary" @click="Save">Save</b-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        product: {}
      }
    },
    props: {
      Model: Object
    },
    methods: {
      async Delete() {
        await this.$http.delete("api/product/" + this.product.Id);
        this.product.deleted = true;
        this.$emit("saved");
        this.$parent.close();
      },
      async Undelete() {
        await this.$http.delete("api/product/" + this.product.Id + "/restore");
        this.product.deleted = false;
        this.$emit("saved");
        this.$parent.close();
      },
      async Save() {
        await this.$http.post("api/product", this.product)
        this.$emit("saved");
        this.$parent.close();
      },
      CreatePlan() {
        this.product.creatingPlan = true;
        this.$http.post("api/payment/plan/new", { productId: this.product.Id }).then(resp => {
          this.product.creatingPlan = false;
          this.product.planId = resp.data;
        }).catch(err => {
          delete this.product.creatingPlan;
          this.$buefy.notification.open({
            duration: 4000,
            message: "An issue occurred while creating the plan.",
            type: 'is-danger',
          });
        });
      },
      RemovePlan() {
        this.product.removingPlan = true;
        this.$http.post("api/payment/plan/remove", { productId: this.product.Id }).then(resp => {
          this.product.removingPlan = false;
          this.product.planId = null;
        }).catch(err => {
          delete this.product.removingPlan;
          this.$buefy.notification.open({
            duration: 4000,
            message: "An issue occurred while creating the plan.",
            type: 'is-danger',
          });
        });
      }
    },
    created() {
      if (this.Model !== undefined)
        this.product = JSON.parse(JSON.stringify(this.Model));
    }
  }
</script>
